import React, {Component} from 'react'
import PropTypes from "prop-types"
import {Field, reduxForm} from 'redux-form'
import {Col, Form, Modal, Row} from "react-bootstrap"
import {DateField, formatDate, SelectField, TextareaField, TextField} from '../form/form'
import {connect} from "react-redux";
import {showMessage} from '../../actions';
import {defaultState} from '../../reducers/entity';
import {BaseStatus, TreatmentType, TreatmentTypeLabel} from "../../utils/enums";
import {createOptions, Date, Enums, resolveApiResult} from "../../utils";
import {showModal} from "../../actions/modal";
import {loadTreatment, saveTreatment} from "../../actions/treatments";
import {handleItemSave, ItemContext, onItemSaveSuccess, renderItemFormButtons, renderItemFormFiles} from "./helpers";
import {loadFiles, saveFile} from "../../actions/files";
import {renderDateField} from "../form/DateField";

const validate = (values) => {
	const errors = {};
	if (!values.treatType) {
		errors.treatType = 'Zvolte prosím typ';
	} else {
		switch (values.treatType) {
			case TreatmentType.OT:
				if (!values.treatDate) {
					errors.treatDate = 'Zvolte prosím datum';
				}
				break;

			case TreatmentType.SHORT:
				if (!values.treatTo) {
					errors.treatTo = 'Zvolte prosím datum';
				}
			// noinspection FallThroughInSwitchStatementJS
			case TreatmentType.CONT:
				if (!values.treatFrom) {
					errors.treatFrom = 'Zvolte prosím datum';
				}
				break;

			default:
		}
	}

	if (!values.treatReason) {
		errors.treatReason = 'Zadejte prosím důvod';
	}

	if (!values.treatTitle) {
		errors.treatTitle = 'Uveďte prosím název léku';
	}

	return errors
}

const textual = (item) => {
	return TreatmentTypeLabel[item.treatType] + ' ' + Date.formatDate(item.treatDate) + ' (ID ' + item.treatmentId + ')';
}

export const createTreatmentInitialValues = (treatmentId, dogId, session) => {
	return treatmentId
		? {dogId, treatmentId}
		: {
			dogId,
			treatDate: Date.format(Date.today(), Date.ISO_DATE),
			treatBy: session.user.userId
		};
}

class TreatmentForm extends Component {

	ctx: ItemContext;

	constructor(props) {
		super(props);

		this.state = {
			treatType: null,
			treatFrom: null,
			treatTo: null,
		}

		this.handleSave = this.handleSave.bind(this);

		this.ctx = {
			itemTag: 'Pokyny',
			itemKeyName: 'treatmentId',
			saveItem: props.saveTreatment,
			saveFile: props.saveFile,
			showMessage: props.showMessage,
			textual,
			onSuccess: (item) => onItemSaveSuccess(item, props)
		}
	}

	componentWillMount() {
		const {treatment} = this.props;
		if (treatment.treatmentId) {
			this.props.loadTreatment(treatment.treatmentId).then((json) => {
				if (resolveApiResult(json)) {
					this.syncEnumsAndState(json.response.data);
				}
			});
			this.props.loadFiles({treatmentId: treatment.treatmentId, statuses: [BaseStatus.ACTIVE]}).then((json) => {
				if (resolveApiResult(json)) {
					this.setState({currentFiles: json.response.data});
				}
			});
		} else {
			this.syncEnumsAndState(treatment);
		}
	}

	syncEnumsAndState(intake) {
		this.setState({
			treatType: intake == null ? null : intake.treatType,
			treatFrom: intake == null ? null : intake.treatFrom,
			treatTo: intake == null ? null : intake.treatTo,
		});
	}

	handleSave(values) {
		const v = {...values};
		if (v.treatType === TreatmentType.CONT || v.treatType === TreatmentType.SHORT) {
			v.treatDate = null;
		} else {
			v.treatFrom = null;
			v.treatTo = null;
		}
		return handleItemSave(this.ctx, v);
	}

	render() {
		const {entity: {item, isFetchingItem}, modal} = this.props;

		return <Modal onHide={modal.onHide} show={true} backdrop={'static'} keyboard={false}>
			{(!item || isFetchingItem) ? null : this.renderForm()}
		</Modal>
	}

	renderForm() {
		const {entity: {item}, initialValues, handleSubmit, modal, enums} = this.props;
		const {treatType, treatFrom, treatTo} = this.state;

		const rows = [];
		let treatReasonLabel;
		let treatByLabel;
		switch (treatType) {
			case TreatmentType.OT:
				rows.push([
					<Row key={'date'}>
						<Col sm={6}>
							<Field label={'Datum'} name={"treatDate"} type="text" component={DateField} maxLength="12" maxDate={Date.today()} format={formatDate}/>
						</Col>
						<Col sm={6}>
							<Field label={'Délka'} name={"treatPeriod"} type="text" component={TextField} maxLength="100"/>
						</Col>
					</Row>,
					<Row key={'title'}>
						<Col sm={12}>
							<Field label={'Přípravek'} name={"treatTitle"} type="text" component={TextField} maxLength="100" sizes={[2, 10]}/>
						</Col>
					</Row>,
				]);
				treatReasonLabel = 'Důvod podání';
				treatByLabel = 'Podal';
				break;

			case TreatmentType.CONT:
			case TreatmentType.SHORT:
				rows.push(<Row key={'treatFrom'}>
						<Col sm={6}>
							{renderDateField({
								label: 'Podávání od', name: "treatFrom", maxDate: treatTo, clearable: true, onChangeHook: (treatFrom) => {
									this.setState({treatFrom})
								}
							})}
						</Col>
						<Col sm={6}>
							{renderDateField({
								label: 'Podávání do', name: "treatTo", minDate: treatFrom, clearable: true, onChangeHook: (treatTo) => {
									this.setState({treatTo})
								}, placeholder: treatType === TreatmentType.SHORT ? null : 'Nekonečno'
							})}
						</Col>
					</Row>,
					treatType === TreatmentType.CONT && <Row key={'treatEndReason'}>
						<Col sm={12}>
							<Field label={'Důvod ukončení'} name={"treatEndReason"} type="text" component={TextareaField}/>
						</Col>
					</Row>,
					<Row key={'title'}>
						<Col sm={12}>
							<Field label={'Přípravek'} name={"treatTitle"} type="text" component={TextField} maxLength="100" sizes={[2, 10]}/>
						</Col>
					</Row>,
					<Row key={'dosageAmount'}>
						<Col sm={6}>
							<Field label={'Množství'} name={"treatAmount"} type="text" component={TextField} maxLength="100"/>
						</Col>
						<Col sm={6}>
							<Field label={'Četnost'} name={"treatDosage"} type="text" component={TextField} maxLength="100"/>
						</Col>
					</Row>);
				treatReasonLabel = 'Důvod podávání';
				treatByLabel = 'Zodpovědná osoba';
				break;

			default:
				break;
		}

		if (treatByLabel) {
			rows.push(<Row key={'treatReason'}>
					<Col sm={12}>
						<Field label={treatReasonLabel} name={"treatReason"} type="text" component={TextareaField}/>
					</Col>
				</Row>,
				<Row key={'treatBy'}>
					<Col sm={6}>
						<Field label={treatByLabel} name={"treatBy"} component={SelectField} options={Enums.createEnumItems(enums, 'user')}/>
					</Col>
				</Row>);
		}

		return <Modal onHide={modal.onHide} show={true} backdrop={'static'} keyboard={false}>
			<Modal.Header>
				<Modal.Title>{initialValues.treatmentId ? 'Úprava pokynů ID ' + initialValues.treatmentId : 'Nové pokyny'}</Modal.Title>
			</Modal.Header>

			<Form horizontal onSubmit={handleSubmit(this.handleSave)} className="detail">
				<Modal.Body>
					<Row key={'treatment'}>
						<Col sm={6}>
							<Field label={'Typ'} name={"treatType"} component={SelectField} options={createOptions(TreatmentTypeLabel)}
								onChangeHook={(treatType) => this.setState({treatType})}/>
						</Col>
					</Row>
					{treatType && rows}
					{treatType && renderItemFormFiles(this.state.currentFiles)}
				</Modal.Body>
				<Modal.Footer>
					{renderItemFormButtons(this.ctx, item, this.props)}
				</Modal.Footer>
			</Form>
		</Modal>
	}
}

TreatmentForm = reduxForm({
	enableReinitialize: true,
	form: 'treatment',
	validate
})(TreatmentForm);

const mapStateToProps = (state, ownProps) => {
	const {
		entities: {treatments, dogs},
		enums,
		session
	} = state;

	const form = state.form['treatment'];
	const {treatment} = ownProps;

	const dog = ((dogs[treatment.dogId] ? dogs[treatment.dogId].item : treatment.dog) || treatment.dog) || {};

	const entity = treatment.treatmentId && treatments[treatment.treatmentId]
		? treatments[treatment.treatmentId]
		: {
			...defaultState,
			item: (form || {}).initial || (treatment.treatmentId ? null : {...treatment})
		};

	return {
		entity,
		initialValues: entity.item,
		dog: dog,
		enums,
		session
	}
}

TreatmentForm.propTypes = {
	dog: PropTypes.object,
	treatment: PropTypes.object.isRequired,
	loadTreatment: PropTypes.func.isRequired,
	loadFiles: PropTypes.func.isRequired,
	saveTreatment: PropTypes.func.isRequired,
	saveFile: PropTypes.func.isRequired,
	showModal: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	modal: PropTypes.object,
	enums: PropTypes.object.isRequired,
	session: PropTypes.object.isRequired
};

export default connect(mapStateToProps, {
	loadTreatment,
	loadFiles,
	saveTreatment,
	saveFile,
	showMessage,
	showModal
})(TreatmentForm)



// WEBPACK FOOTER //
// ./src/components/dog/TreatmentForm.js